import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Loader } from '@gravity-ui/uikit';

import { useLazyConfirmConsentPatientQuery } from 'store/api';

import styles from './styles.module.scss';

export const ConsentPage = () => {
	const { token } = useParams();
	const [triggerConfirmConsent, { data, error, isLoading }] = useLazyConfirmConsentPatientQuery();

	useEffect(() => {
		if (token) {
			triggerConfirmConsent(token);
		}
	}, [token, triggerConfirmConsent]);

	return (
		<>
			{isLoading ? (
				<div className={styles.consent}>
					<Loader />
				</div>
			) : (
				<div className={styles.consent}>Подтверждение согласия получено</div>
			)}
		</>
	);
};
